import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { routes } from '../../constants/routes';
import { useGetBasketById } from '../../lib/hooks/use-get-basket-by-id';
import { Spinner } from '../spinner';
import { ApiBasket } from '../../api/basketService';
import { getBasketFromStorage } from '../../utils/local-storage-versioning';

export function BasketGuard<T extends { basket: ApiBasket }>(props: {
    component: FC<T>;
    componentProps: Omit<T, 'basket'>;
}): ReactElement | null {
    const storedBasket = getBasketFromStorage();
    const { component: Component, componentProps } = props;
    const { data: basket, isLoading: isBasketLoading, isError: isBasketError } = useGetBasketById();

    if (!storedBasket || !storedBasket.id) {
        return <Navigate to={routes.noRoomSelected.index} />;
    }

    if (isBasketLoading) {
        return <Spinner />;
    }

    if (!basket || isBasketError) {
        return <Navigate to={routes.noRoomSelected.index} />;
    }

    return <Component {...(componentProps as T)} basket={basket} />;
}
